import React from 'react';
import CountView from '../CountView/CountView';
import useFlatIndicatorRequestCount from '../../../../../../hooks/useFlatIndicatorRequestCount';
import { declensions } from '../../../../../../constants/declensions';

const FlatExcessCountView = ({ requests = [] }) => {
  const values = useFlatIndicatorRequestCount(requests);

  return (
    <CountView
      values={values}
      words={declensions.request}
    />
  );
};

export default FlatExcessCountView;
